import { CATALOG_API_CLIENT } from "../../../App.utils";

export const isSiteUnderMaintenance = async () => {
  try {
    const response = await CATALOG_API_CLIENT.get(
      "/catalog/site-under-maintenance"
    );
    return response.data;
  } catch (err) {
    console.log(err);
  }
};
